import {Component, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {Subscription} from 'rxjs';
import {AlertService} from '../../service/alert.service';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap/modal';

@Component({
    selector: 'app-alert',
    templateUrl: './alert.component.html',
    styleUrls: ['./alert.component.scss'],
    standalone: false
})
export class AlertComponent implements OnInit, OnDestroy
{

    @ViewChild('content') content: any;
    message: any;
    countdownSeconds: number = 0;
    private subscription: Subscription;
    private countdownInterval: ReturnType<typeof setInterval> | null = null;

    constructor(private alertService: AlertService, private modalService: NgbModal)
    {
    }

    get countdownMinutes(): number
    {
        return Math.floor(this.countdownSeconds / 60);
    }

    get countdownRemainingSeconds(): number
    {
        return this.countdownSeconds % 60;
    }

    ngOnInit()
    {
        this.subscription = this.alertService.getMessage().subscribe(message =>
        {

            this.message = message;
            this.stopCountdown();

            if (message)
            {
                if (message.type === 'LOCKOUT' && message.remainingSeconds > 0)
                {
                    this.startCountdown(message.remainingSeconds);
                }

                this.modalService.open(this.content, {
                    centered: true,
                    backdrop: 'static',
                    keyboard: false
                }).result.then((result) =>
                {
                    this.clearMessage();
                }, (reason) =>
                {
                    this.clearMessage();
                });
            }
        });
    }

    ngOnDestroy()
    {
        if (this.subscription)
        {
            this.subscription.unsubscribe();
        }
        this.stopCountdown();
    }

    clearMessage()
    {
        this.message = null;
        this.stopCountdown();
    }

    private startCountdown(seconds: number)
    {
        this.countdownSeconds = seconds;
        this.countdownInterval = setInterval(() =>
        {
            if (this.countdownSeconds > 0)
            {
                this.countdownSeconds--;
            }
            else
            {
                this.stopCountdown();
            }
        }, 1000);
    }

    private stopCountdown()
    {
        if (this.countdownInterval !== null)
        {
            clearInterval(this.countdownInterval);
            this.countdownInterval = null;
        }
        this.countdownSeconds = 0;
    }
}
